/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PreviewEquipmentBulkEditViewRequestBody = {
  /**
   * Display template to preview
   */
  displayTemplate: string;
};

/** @internal */
export const PreviewEquipmentBulkEditViewRequestBody$inboundSchema: z.ZodType<
  PreviewEquipmentBulkEditViewRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  display_template: types.string(),
}).transform((v) => {
  return remap$(v, {
    "display_template": "displayTemplate",
  });
});
/** @internal */
export type PreviewEquipmentBulkEditViewRequestBody$Outbound = {
  display_template: string;
};

/** @internal */
export const PreviewEquipmentBulkEditViewRequestBody$outboundSchema: z.ZodType<
  PreviewEquipmentBulkEditViewRequestBody$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBulkEditViewRequestBody
> = z.object({
  displayTemplate: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayTemplate: "display_template",
  });
});

export function previewEquipmentBulkEditViewRequestBodyToJSON(
  previewEquipmentBulkEditViewRequestBody:
    PreviewEquipmentBulkEditViewRequestBody,
): string {
  return JSON.stringify(
    PreviewEquipmentBulkEditViewRequestBody$outboundSchema.parse(
      previewEquipmentBulkEditViewRequestBody,
    ),
  );
}
export function previewEquipmentBulkEditViewRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PreviewEquipmentBulkEditViewRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PreviewEquipmentBulkEditViewRequestBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PreviewEquipmentBulkEditViewRequestBody' from JSON`,
  );
}
